import { useMemo } from 'react'

import { matchI18nPath, matchI18nPathList } from './helpers'

export const useMatch = (path: string, startsWith?: boolean) => {
  return useMemo(
    () =>
      matchI18nPath(path, {
        pathname: window.location.pathname,
        startsWith,
      }),
    [startsWith, window.location.pathname, path]
  )
}

export const useMatchList = (pathList: string[], startsWith?: boolean) => {
  return useMemo(
    () =>
      matchI18nPathList(pathList, {
        pathname: window.location.pathname,
        startsWith,
      }),
    [startsWith, window.location.pathname, ...pathList]
  )
}
